import { TrialTopHeader } from '@iblai/ibl-web-react-common';
import useFreeTrial from '../../hooks/freetrial/useFreeTrial';
import { useSelector } from 'react-redux';
import { mentorIsIframe, userIsOnTrial } from '../../utils/shared';
import { useTriggers } from '../../hooks/navigation';

export default function FreeTrialBanner() {
  const auth = useSelector((state) => state.auth);
  const { handleUpgradeClick } = useFreeTrial(false);
  const { handleSeePricingIframeBoxClick } = useTriggers();

  const tooltip = `You can chat with the mentors but upgrade in order to create your own. ${auth?.freeTrialUsage?.count} questions left.`;
  const pillDisplay = `Upgrade`;
  const description = `You are on a free trial. ${auth?.freeTrialUsage?.count} questions left`;
  return (
    <>
      {userIsOnTrial() && auth?.freeTrialUsage?.count && !mentorIsIframe() && (
        <TrialTopHeader
          handleClick={handleSeePricingIframeBoxClick}
          tooltipText={tooltip}
          pillDisplayText={pillDisplay}
          descriptionText={description}
          fixedClassNamesToMove=".header, .main-content"
        />
      )}
    </>
  );
}
